import React, { useEffect, useState } from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';
import moment from 'moment';
import  './Modal.css';
import { constants } from '../../../constants';

function Modal(props) {
  const {show,hideModal,rec,mobile,handleContinue,userMsg} = props;
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    if(show) {
        setIsChecked(false)
    }
  }, [show])

  const handleCheckboxClick = (e) => {
    if(e.target.checked === true) {
        setIsChecked(true)
    }else {
        setIsChecked(false)
    }
  }
// Flatten all examSeries for logging if in non-production
    let flatSeries = [];
    if (rec?.section === "summary" && Array.isArray(rec.series)) {
        flatSeries = rec.series.flatMap(e => {
            if (Array.isArray(e.examSeries)) return e.examSeries;
            if (typeof e.examSeries === 'string') return [e.examSeries];
            if (typeof e.examSeries === 'object' && e.examSeries !== null) {
                if (e.examSeries.session) return [e.examSeries.session];
                if (e.examSeries.noSession) return [e.examSeries.noSession];
                return [];
            }
            return [];
        });
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.log('flatSeries for modal:', flatSeries);
        }
    }

    return (
        <>
            <BootstrapModal scrollable={true} animation={false} centered='true' dialogClassName={`modal-size center-view ${rec === 'paymentDue' && 'paymentDueMessage'} ${rec === 'duplicatePayment' && 'duplicatePaymentMessage'} ${rec === 'review' && 'reviewModel'} ${rec === 'adyen' && 'adyenForm'}`} show={show} onHide={hideModal}>
                <BootstrapModal.Header className='no-border'>
                    {rec !== "adyen" && (
                        <button type="button" className="modal-close-btn" aria-label="Close" onClick={hideModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    )}
                </BootstrapModal.Header>
                <BootstrapModal.Body>
                    { rec?.section === "summary" ?
                        <div>
                            <p className='head-label'>Order Summary</p>
                            <p><label className='head-label mr-2'>Request date:</label>{moment(rec.orderDate).format('DD MMMM yyyy')}</p>
                            <p><label className='head-label mr-2'>Email address:</label>{rec.emailAddress}</p>
                            <p><label className='head-label mr-2'>Order number:</label>{rec.applicationReferenceNumber}</p>
                            <div className={mobile?"":'row pl-3'}>
                                <div className="mr-2">
                                    <span className="head-label">Series</span>
                                    {Array.isArray(rec.series) && rec.series.length > 0 ? (
                                        rec.series.map((e, i) => {
                                            // Defensive: e.examSeries can be array, string, object, or undefined
                                            let examSeriesArr = [];
                                            let onlyNoSession = false;
                                            if (Array.isArray(e.examSeries)) {
                                                // Check if every item is an object with only noSession property
                                                onlyNoSession = e.examSeries.length > 0 && e.examSeries.every(
                                                    (item) => typeof item === 'object' && item !== null && item.noSession && !item.session
                                                );
                                                if (onlyNoSession) {
                                                    examSeriesArr = [];
                                                } else {
                                                    examSeriesArr = e.examSeries;
                                                }
                                            } else if (typeof e.examSeries === 'string') {
                                                examSeriesArr = [e.examSeries];
                                            } else if (typeof e.examSeries === 'object' && e.examSeries !== null) {
                                                if (e.examSeries.session) {
                                                    examSeriesArr = [e.examSeries.session];
                                                } else if (e.examSeries.noSession) {
                                                    examSeriesArr = [];
                                                } else {
                                                    examSeriesArr = [];
                                                }
                                            }
                                            // If examSeriesArr is empty, show 'No series available'
                                            return (
                                                <React.Fragment key={i}>
                                                    {i > 0 && <p className='invisible'>&nbsp;</p>}
                                                    {examSeriesArr.length > 0 ? examSeriesArr.map((s, j) => {
                                                        let label = s;
                                                        if (typeof s === 'object' && s !== null) {
                                                            if (s.session) label = s.session;
                                                            else if (s.noSession) label = s.noSession;
                                                            else return <p key={j}>No series available</p>;
                                                        }
                                                        return <p key={j}>{label} {rec.qualification}</p>;
                                                    }) : <p>No series available</p>}
                                                </React.Fragment>
                                            );
                                        })
                                    ) : <p>No series available</p>}
                                </div>
                                <div className={mobile?"mt-4":"ml-5"}>
                                    <span className="head-label">Status</span>
                                    {Array.isArray(rec.series) && rec.series.length > 0 ? (
                                        rec.series.map((e, i) => {
                                            let examSeriesArr = [];
                                            if (Array.isArray(e.examSeries)) {
                                                examSeriesArr = e.examSeries;
                                    } else if (typeof e.examSeries === 'string') {
                                        examSeriesArr = [e.examSeries];
                                    } else if (typeof e.examSeries === 'object' && e.examSeries !== null) {
                                        if (e.examSeries.session) {
                                            examSeriesArr = [e.examSeries.session];
                                        } else if (e.examSeries.noSession) {
                                            examSeriesArr = [e.examSeries.noSession];
                                        } else {
                                            examSeriesArr = [JSON.stringify(e.examSeries)];
                                        }
                                    }
                                    return (
                                        <React.Fragment key={i}>
                                            {i > 0 && !mobile && <p className='invisible'>&nbsp;</p>}
                                            {examSeriesArr.length > 0 ? examSeriesArr.map((s, j) => {
                                                // Defensive: don't render object as child
                                                let label = '';
                                                if (typeof s === 'object' && s !== null) {
                                                    if (s.session) label = s.session;
                                                    else if (s.noSession) label = s.noSession;
                                                    else label = JSON.stringify(s);
                                                }
                                                return <p key={j} className='i-font'>{e.applicationStatus || e.status || label}</p>;
                                            }) : <p className='i-font'>No status available</p>}
                                        </React.Fragment>
                                    );
                                })
                            ) : <p className='i-font'>No status available</p>}
                        </div>
                    </div>
                    <div>
                        <div className="head-label mr-2 mt-4">Institutions</div>                        
                        {rec.institutions.map((e,i)=>{ return(<p key={i} className='mb-0'>{e.split(',')[0]}</p>)})}
                    </div>                    
                    <div>
                        <div className="head-label mt-4">Payment</div>
                        <p className='i-font'>$-{rec.payment.amount}{rec.payment.currency}</p>       
                    </div>
                    <p><label className='head-label mr-2'>Payment confirmation</label>{rec.payment.paymentReferenceNumber}</p>                                                
                    <div>
                        <button data-testid='printModal' type="button" onClick={() => window.print()} className="btn font-weight-bold save-button-confirmation text-white">Print</button> 
                    </div>
                </div>
                :rec?.section === "scores"?
                <div>
                    <div><span className='italic head-label'>Unofficial report of sent grades</span><br/>
                        <span className='head-label'>not official transcript</span>
                    </div>
                    <p className='head-label mt-4'>SCORES</p>
                    { rec.scores.examSeries.length>0 ?
                        <>
                          <table>               
                            <thead><tr>{constants.modal.scoresHeaders.map((h,i)=><th className={i>0?'pl-5':''} key={i}>{h}</th>)}</tr></thead>
                            <tbody id='scoresBody'>
                                {rec.scores.examSeries.map((m,j)=>{return(
                                    <tr key={j}>
                                        <td style={{wordBreak:'break-word',verticalAlign:'top'}}><p>{m.series} {m.qualificationLevel}</p></td>                                        
                                        <td className='pl-5' style={{wordBreak:'break-word',verticalAlign:'top'}}>{m.subjects.map((s,k)=>{return(<p key={k}>{s.syllabus}</p>)})}</td>
                                        <td className='pl-5' style={{verticalAlign:'top'}}>{m.subjects.map((s,k)=>{return(<p key={k}>{s.grade}</p>)})}</td>
                                    
                                    </tr>)})}
                            </tbody>              
                          </table>
                          <div className='mt-4'>
                            <button data-testid='printModal' type="button" onClick={() => window.print()} className="btn font-weight-bold save-button-confirmation text-white">Print</button> 
                          </div>
                        </>
                        :
                        rec.scores.examSeries.length === 0?<span className='italic'>No scores available</span>:""
                    }       
                </div>
                : rec === "paymentDue" ?
                <div>
                    <div>
                        <p className='messageSection'>The deadline to make payment has expired. Please begin a new application and pay within 48 hours to submit your application.</p>
                    </div>
                    <div className='mt-4 d-flex justify-content-center'>
                        <button type="button" className="btn font-weight-bold save-button-confirmation text-white btnWidth" onClick={hideModal}>OK</button> 
                    </div>
                </div>
                : rec === "duplicatePayment" ?
                <div>
                    <div>
                    <p className='messageSection'>Payment is currently being processed for this application. No further action is required.</p>
                    </div>
                    <div className='mt-4 d-flex justify-content-center'>
                        <button type="button" className="btn font-weight-bold save-button-confirmation text-white btnWidth" onClick={hideModal}>OK</button> 
                    </div>
                </div>
                : rec === "review" ?
                <div>
                    <span className='review-label'>
                        <input type="checkbox" className="c-b-size" onClick={handleCheckboxClick} />
                        <p className='m-0'>Please tick to confirm you have requested transcripts for all exams you would like to be sent across all series in which you tested.</p>
                    </span>
                    <div className='mt-4 d-flex justify-content-center' style={{ gap:'5px'}}>
                        <button type="button" className="btn font-weight-bold continue-button text-white" onClick={hideModal}>Return to application</button>  
                        <button type="button" disabled={!isChecked} className="btn font-weight-bold continue-button text-white" onClick={handleContinue}>Continue</button>
                    </div>
                </div>
                : rec === "adyen"?
                <div>
                    <div>
                        <p className='messageSection'>Unfortunately, your payment has not been successful</p>
                        <p className='messageSection mt-2 justify-content-center'>{userMsg}</p>
                    </div>
                    <div className='mt-4 d-flex justify-content-center'>
                        <button type="button" className="btn font-weight-bold save-button-confirmation text-white adyen_btnWidth" onClick={hideModal}>Return to payment screen</button> 
                    </div>
                </div>:
                <div>
                    <p className='head-label'>Contact us</p>
                    <div>
                        <div className="head-label mr-2 mt-4">Contact by phone</div>
                        <p>917-810-2660</p>
                    </div>
                    <div>
                        <div className="head-label mr-2 mt-4">Contact by email</div>
                        <p>info@cambridgeinternational.org</p>
                    </div>
                </div>
                }
            </BootstrapModal.Body>
        </BootstrapModal>
    </>
  );
}
export default Modal;
